import { render, staticRenderFns } from "./ConsultantFinalizeCart.vue?vue&type=template&id=bb688ef0&scoped=true"
import script from "./ConsultantFinalizeCart.vue?vue&type=script&lang=js"
export * from "./ConsultantFinalizeCart.vue?vue&type=script&lang=js"
import style0 from "./ConsultantFinalizeCart.vue?vue&type=style&index=0&id=bb688ef0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb688ef0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb688ef0')) {
      api.createRecord('bb688ef0', component.options)
    } else {
      api.reload('bb688ef0', component.options)
    }
    module.hot.accept("./ConsultantFinalizeCart.vue?vue&type=template&id=bb688ef0&scoped=true", function () {
      api.rerender('bb688ef0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cart/ConsultantFinalizeCart.vue"
export default component.exports